const isMobile = window.innerWidth < 768;

function createGoogleReviewBox() {
  const stars = document.querySelectorAll('.grp-entangle-badge-stars svg');
  const reviewCount = document.querySelector('.grp-main-hyper-link b').innerText.trim();

  document.querySelectorAll('.jci-google-reviews-pill').forEach(targetContainer => {
    // Create a link for the review box
    const reviewBox = document.createElement('a');
    reviewBox.className = 'google-review-box';
    reviewBox.href = 'https://g.co/kgs/wDfaaci'; // Link to Google reviews
    reviewBox.target = '_blank'; // Open link in a new tab
    reviewBox.rel = 'noopener noreferrer'; // Security and performance best practice

    // Google logo container
    const googleLogoContainer = document.createElement('div');
    googleLogoContainer.className = 'google-logo';

    // Replace the Google logo with the updated image
    const googleLogoImg = document.createElement('img');
    googleLogoImg.src = 'https://cdn.shopify.com/s/files/1/0676/1414/6828/files/google-logo.png?v=1734968724';
    googleLogoImg.alt = 'Google Logo';
    googleLogoImg.style.maxHeight = '21px'; // Adjust the size as necessary
    googleLogoContainer.appendChild(googleLogoImg);

    // Stars and review count wrapper
    const starsReviewWrapper = document.createElement('div');
    starsReviewWrapper.className = 'stars-review-wrapper';

    // Stars container
    const starsContainer = document.createElement('div');
    starsContainer.className = 'stars-container';
    stars.forEach(star => {
      starsContainer.appendChild(star.cloneNode(true));
    });

    // Review count container
    const reviewCountElement = document.createElement('div');
    reviewCountElement.className = 'review-count';
    reviewCountElement.textContent = isMobile
      ? `${reviewCount}`
      : `Based on ${reviewCount}`;

    // Append stars and review count to the wrapper
    starsReviewWrapper.appendChild(starsContainer);
    starsReviewWrapper.appendChild(reviewCountElement);

    // Append elements to the review box
    reviewBox.appendChild(googleLogoContainer);
    reviewBox.appendChild(starsReviewWrapper);

    // Append review box to the target container
    targetContainer.appendChild(reviewBox);
    targetContainer.style.opacity = '1';
  });
}

function createTrustpilotReviews() {
  const iframe = document.querySelector('.trustview-widget iframe');

  if (iframe) {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    if (iframeDoc) {
      const trustScore = iframeDoc.querySelector('#trust-score')?.innerText || '';
      const starRating = iframeDoc.querySelector('#tp-widget-stars')?.innerHTML || '';
      const reviewCount = iframeDoc.querySelector('#translations-basedon')?.innerHTML || '';

      console.log(reviewCount);

      document.querySelectorAll('.jci-google-reviews-pill').forEach(widgetContainer => {
        widgetContainer.innerHTML = `
          <a href="https://www.trustpilot.com/review/basicfatbikes.nl" target="_blank" rel="noopener noreferrer">
            <div class="jci-trustpilot-widget">
              <div class="logo-container">
                <img src="https://cdn.shopify.com/s/files/1/0676/1414/6828/files/trustpilot-logo.png?v=1734930275" alt="Trustpilot Logo">
              </div>
              <div class="stars-container">
                <div class="custom-stars">${starRating}</div>
                <p class="reviews">${isMobile ? reviewCount.replace('Based on ', '') : reviewCount}</p>
              </div>
            </div>
          </a>
        `;

        const starStyleSheet = [...iframeDoc.styleSheets].find(sheet =>
          sheet.href === null || sheet.href.startsWith(window.location.origin)
        );
        if (starStyleSheet) {
          try {
            const rules = starStyleSheet.cssRules || starStyleSheet.rules;
            const styleElement = document.createElement('style');
            for (let rule of rules) {
              if (rule.selectorText && rule.selectorText.includes('.tp-stars')) {
                styleElement.textContent += rule.cssText;
              }
            }
            document.head.appendChild(styleElement);
          } catch (err) {
            console.error('Error accessing iframe CSS rules:', err);
          }
        }
      });
    } else {
      console.error('Unable to access iframe content. Ensure the iframe is on the same origin or uses CORS headers.');
    }
  } else {
    console.error('Iframe not found. Check the selector or ensure the iframe exists in the DOM.');
  }
}




window.addEventListener('load', () => {
  setTimeout(() => {
    createTrustpilotReviews();
    createGoogleReviewBox();
    $('.template-product .jci-loader').remove();
  }, 2400);
});

